import create from 'zustand'
import { CST_MEMBERSHIP } from '../Constants/costs'

const [useStore] = create((set) => ({
  //COMMONS
  loading: false,
  setLoading: (payload) => set(() => ({ loading: payload })),
  message: false,
  setAlertMessage: (payload) => set(() => ({ message: payload })),
  aircraft: undefined,
  setAircraft: (payload) => set(() => ({ aircraft: { ...payload } })),
  termsOpen: false,
  setTermsDialog: (payload) => set(() => ({ termsOpen: payload })),
  defaultProfitArray: 0,
  setDefaultProfitArray: (payload) =>
    set(() => ({ defaultProfitArray: payload })),
  //MX RELATED
  mxDistances: [],
  setMxAirspace: (payload) => set(() => ({ mxDistance: [...payload] })),
  exchangeRate: 0,
  setExchangeRate: (payload) => set(() => ({ exchangeRate: payload })),
  //COF RELATED
  cofFirstStep: {},
  setCOFFirstStep: (formData) => set(() => ({ ...formData })),
  isRoundTrip: false,
  setIsRoundTrip: (payload) => set(() => ({ isRoundTrip: payload })),
  tripTypeSelected: false,
  setTripTypeSelected: (payload) => set(() => ({ tripTypeSelected: payload })),
  leg1Route: '',
  setLeg1Route: (payload) => set(() => ({ leg1Route: payload })),
  leg2Route: '',
  setLeg2Route: (payload) => set(() => ({ leg2Route: payload })),
  //COST RELATED
  rushService: false,
  setRushService: (payload) => set(() => ({ rushService: payload })),
  membershipRequest: false,
  setMembershipRequest: (payload) =>
    set(() => ({ membershipRequest: payload })),
  isMember: false,
  setIsMember: (payload) => set(() => ({ isMember: payload })),
  totalMxCost: 0,
  setTotalMxCost: (payload) => set(() => ({ totalMxCost: payload })),
  totalMxProfit: 0,
  setTotalMxProfit: (payload) => set(() => ({ totalMxProfit: payload })),
  totalBoeCost: 0,
  setTotalBoeCost: (payload) => set(() => ({ totalBoeCost: payload })),
  totalCofCost: 0,
  setTotalCofCost: (payload) => set(() => ({ totalCofCost: payload })),
  //MEMBERSHIP & DISCOUNT
  rushServiceCost: 0,
  setRushServiceCost: (payload) => set(() => ({ rushServiceCost: payload })),
  cstMembership: CST_MEMBERSHIP,
  setMembershipPrice: (payload) => set(() => ({ cstMembership: payload })),
  memberDiscount: 0,
  setMemberDiscount: (payload) => set(() => ({ memberDiscount: payload })),
  // BOE RELATED
  termsOfUse: {
    hasAgree: 'no',
    dialogStatus: 'close',
  },
  setTermsOfUse: (payload) => set(() => ({ termsOfUse: { ...payload } })),
  affirmationOfComply: {
    hasAgree: 'no',
    dialogStatus: 'close',
  },
  setAffirmationOfComply: (payload) =>
    set(() => ({ affirmationOfComply: { ...payload } })),
  aircraftBehavior: {
    hasAgree: 'no',
    dialogStatus: 'close',
  },
  setAircraftBehavior: (payload) =>
    set(() => ({ aircraftBehavior: { ...payload } })),
}))

export { useStore }
